import React, { useState, useEffect } from 'react';
import { FaMobileAlt, FaQrcode } from 'react-icons/fa';
import logo from '../../assets/logo.svg';
import qrCode from '../../assets/qr.png';
import './DesktopBlocker.css';

const DesktopBlocker = ({ children }) => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      // Check if screen width is greater than 1024px (typical tablet/desktop)
      const isLargeScreen = window.innerWidth > 1024;
      setIsDesktop(isLargeScreen);
    };

    // Check on mount
    checkDevice();

    // Add event listener for window resize
    window.addEventListener('resize', checkDevice);

    // Cleanup
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  if (!isDesktop) {
    return <>{children}</>;
  }

  return (
    <div className="desktop-blocker">
      <div className="desktop-blocker-container">
        {/* Left Side - Content */}
        <div className="desktop-blocker-left">
          {/* Logo */}
          <div className="desktop-blocker-logo">
            <img src={logo} alt="App Logo" />
          </div>

          {/* Message */}
          <div className="desktop-blocker-message">
            <h1>Use Indian Festival Calendar on your mobile phone</h1>
            <p className="desktop-blocker-subtitle">
              This app is optimized for mobile devices and provides the best experience on smartphones and tablets.
            </p>
          </div>

          {/* Instructions */}
          <div className="desktop-blocker-steps">
            <div className="desktop-blocker-step">
              <span className="desktop-blocker-step-number">1</span>
              <div className="desktop-blocker-step-content">
                <strong>Open your phone's camera</strong>
                <p>Point it at the QR code on the right</p>
              </div>
            </div>
            <div className="desktop-blocker-step">
              <span className="desktop-blocker-step-number">2</span>
              <div className="desktop-blocker-step-content">
                <strong>Scan the QR code</strong>
                <p>Your phone will detect the code automatically</p>
              </div>
            </div>
            <div className="desktop-blocker-step">
              <span className="desktop-blocker-step-number">3</span>
              <div className="desktop-blocker-step-content">
                <strong>Start using the app</strong>
                <p>Enjoy all features on your mobile device</p>
              </div>
            </div>
          </div>

          {/* Footer Note */}
          <div className="desktop-blocker-note">
            <FaMobileAlt className="desktop-blocker-note-icon" />
            <p>For the best experience, please use a mobile device</p>
          </div>
        </div>

        {/* Right Side - QR Code */}
        <div className="desktop-blocker-right">
          <div className="desktop-blocker-qr-card">
            <div className="desktop-blocker-qr-container">
              <img src={qrCode} alt="QR Code" className="desktop-blocker-qr-image" />
            </div>
            <div className="desktop-blocker-qr-footer">
              <FaQrcode className="desktop-blocker-qr-icon" />
              <span>Scan with your phone camera</span>
            </div>
          </div>
        </div>
      </div>

      {/* Background Decoration */}
      <div className="desktop-blocker-bg-decoration">
        <div className="desktop-blocker-circle desktop-blocker-circle-1"></div>
        <div className="desktop-blocker-circle desktop-blocker-circle-2"></div>
      </div>
    </div>
  );
};

export default DesktopBlocker;
